/** When your routing table is too long, you can split it into small modules**/
import Layout from '@/layout';

const adminRoutes = {
  path: '/administrator',
  component: Layout,
  redirect: '/administrator/users',
  name: 'Administrator',
  alwaysShow: true,
  meta: {
    title: 'administrator',
    icon: 'avatar',
  },
  children: [
    /** User managements */
    {
      path: 'users/edit/:id(\\d+)',
      component: () => import('../views/users/UserProfile'),
      name: 'UserProfile',
      meta: {
        title: 'userProfile',
        noCache: true,
        permissions: ['user view'],
      },
      hidden: true,
    },
    {
      path: 'users',
      component: () => import('../views/users/List'),
      name: 'UserList',
      meta: { title: 'users', icon: 'user', permissions: ['user view'] },
    },
    {
      path: 'edit/user/permission/:id(\\d+)',
      component: () => import('../views/users/components/Permisions'),
      name: 'EditUserPermission',
      meta: {
        title: 'EditPermission',
        icon: 'edit',
        permissions: ['user permission view', 'user permission update'],
      },
      hidden: true,
    },
    // employees management

    {
      path: 'employees',
      component: () => import('../views/employees/List'),
      name: 'EmployeeList',
      meta: {
        title: 'EmployeeList',
        icon: 'Memo',
        permissions: ['employee view'],
      },
    },
    {
      path: 'employees/edit/:id(\\d+)',
      component: () => import('../views/employees/components/EditEmployee'),
      name: 'EmployeeProfile',
      meta: {
        title: 'EmployeeProfile',
        noCache: true,
        permissions: ['employee view'],
      },
      hidden: true,
    },
    /** Role and permission */
    {
      path: 'roles',
      component: () => import('../views/role-permission/List'),
      name: 'RoleList',
      meta: {
        title: 'rolePermission',
        icon: 'EditPen',
        permissions: ['role permission view'],
      },
    },
    {
      path: 'edit/permission/:id(\\d+)',
      component: () => import('../views/role-permission/Permisions'),
      name: 'EditPermission',
      meta: {
        title: 'EditPermission',
        icon: 'edit',
        permissions: ['role permission view', 'role permission update'],
      },
      hidden: true,
    },
    // supplier routes
    {
      path: 'suppliers',
      component: () => import('../views/supplier/List'),
      name: 'supplierList',
      meta: { title: 'supplierList', icon: 'Memo', permissions: ['supplier view'] },
    },
    {
      path: 'suppliers/edit/:id(\\d+)',
      component: () => import('../views/supplier/components/SupplierEdit'),
      name: 'EditSupplier',
      meta: {
        title: 'supplierProfile',
        noCache: true,
        permissions: ['supplier view'],
      },
      hidden: true,
    },
    // clients routes
    {
      path: 'clients',
      component: () => import('../views/client/List'),
      name: 'ClientList',
      meta: { title: 'clientList', icon: 'Memo', permissions: ['client view'] },
    },
    {
      path: 'clients/edit/:id(\\d+)',
      component: () => import('../views/client/components/ClientEdit'),
      name: 'EditClient',
      meta: {
        title: 'clientProfile',
        noCache: true,
        permissions: ['client view'],
      },
      hidden: true,
    },

    // activity log routes
    {
      path: 'activity-log',
      component: () => import('../views/activity/List'),
      name: 'ActivityList',
      meta: {
        title: 'activityList',
        icon: 'Memo',
        permissions: ['activity log view'],
      },
    },
  ],
};

export default adminRoutes;
